import script from "./ViewInspectionDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewInspectionDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ViewInspectionDashboard.vue?vue&type=style&index=0&id=1c602cf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c602cf0"]])

export default __exports__